import styled, { breakpoints } from '../../../../../styles/theme';
import { StockModelCardOptionsStyled } from '../StockModelCardOptionsStyled';
import { rem } from 'polished';

export const StockModelCardOptionsStyledDS = styled(StockModelCardOptionsStyled)`
    .tooltipPlaceholder {
        margin-top: ${rem('60px')};
        min-height: ${rem('18px')};
    }

    .stockModelCard-options {
        &--heading {
            font-size: ${rem('16px')};
        }

        &--item {
            font-size: ${rem('16px')};
            margin-left: 1rem;

            &::before {
                left: -0.8rem;
                background-color: ${({ theme }) => theme.colors.red1};
                border-radius: 0;
            }
        }
        &--tooltipItem {
            svg {
                g {
                    circle,
                    line {
                        stroke: ${({ theme }) => theme.colors.secondary};
                    }
                }
            }
        }
    }
    .cardOptionTooltipItem--tooltipItem__title {
        color: ${({ theme }) => theme.colors.black};
        font-size: ${({ theme }) => theme.fontSizes.h5};
    }
`;
